import { AxiosPromise } from 'axios';

import * as params from '../constants/params';

import { pulseInstance } from './config';
import { res } from './utils';

type PulseParams = {
  asset: string;
};

const getPulse = (path = 'unknown', { asset }: PulseParams): AxiosPromise =>
  pulseInstance
    .get(path, {
      params: {
        [params.ASSET]: asset,
      },
    })
    .then(res);

export default {
  getPulse,
};
